import {OverlayModule} from '@angular/cdk/overlay';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';

import {MatTreeModule} from '@angular/material/tree';
import {NbSecurityModule} from '@nebular/security';
import {
  NbActionsModule,
  NbBadgeModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbIconModule,
  NbRadioModule,
  NbSelectModule,
  NbSpinnerModule,
  NbToggleModule,
  NbTooltipModule
} from '@nebular/theme';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormlyModule} from '@ngx-formly/core';
import {ResizableModule} from 'angular-resizable-element';
import {TableModule} from 'compob2b-table';
import {AdminSharedModule} from '../../../admin-shared/admin-shared.module';
import {CompoTreeComponent} from '../../../admin-shared/crud-components/compo-tree/compo-tree.component';

import {CatalogRoutingModule} from './catalog-routing.module';
import {CreateUpdateCatalogComponent} from './create-update/create-update-catalog.component';
import {GrabberDirective, ResizableDirective} from './directives/resize.directive';
import {CatalogLazyComponent} from './lazy-tree/catalog-lazy.component';

@NgModule({
  declarations: [CatalogLazyComponent, CreateUpdateCatalogComponent, CompoTreeComponent, ResizableDirective, GrabberDirective],
  exports: [
    CompoTreeComponent,
    ResizableDirective,
    GrabberDirective
  ],
  imports: [
    CommonModule,
    CatalogRoutingModule,
    ReactiveFormsModule,
    AdminSharedModule,
    NbCardModule,
    TableModule,
    NbButtonModule,
    NbIconModule,
    NbActionsModule,
    NgSelectModule,
    NbToggleModule,
    NbTooltipModule,
    FormlyModule,
    NbSelectModule,
    NbBadgeModule,
    NbSpinnerModule,
    MatTreeModule,
    MatButtonModule,
    MatMenuModule,
    OverlayModule,
    NbCheckboxModule,
    NbRadioModule,
    ResizableModule,
    NbSecurityModule
  ]
})
export class CatalogModule {
}
